// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-floating-promises, react-hooks/exhaustive-deps, react-hooks/immutability */

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Loader, Segment } from "semantic-ui-react";

import { useDispatch } from "react-redux";

import moment from "moment";
import { useAuth0 } from "../../../../auth/auth0";
import { useModuleNavigation } from "../../../../hooks/useModuleNavigation";
import { useUserAuth } from "../../../../hooks/useUserAuth";

import * as groundDataActions from "../../../../redux/actions/groundDataActions";
import NewGroundData from "../../../Lumber/GroundData/NewGroundData";

import { toast } from "react-toastify";

const TrialGroundData = () => {
	const dispatch = useDispatch();
	const { getTokenSilently } = useAuth0();
	const userAuth = useUserAuth();
	const moduleNavigation = useModuleNavigation();
	const history = useHistory();

	//-- Data Sources
	const [groundDataQuestions, setGroundDataQuestions] = useState(null);
	const [growthStages, setGrowthStages] = useState([]);
	const [persons, setPersons] = useState([]);
	const [trialOutlineData, setTrialOutlineData] = useState([]);

	//-- UI Control
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (userAuth.currentClientId && !groundDataQuestions) {
			getGroundDataInfo();
		}
	}, [userAuth.currentClientId]);

	async function getGroundDataInfo() {
		const accessToken = await getTokenSilently();
		setLoading(true);
		dispatch(groundDataActions.getGroundDataInfo("", moduleNavigation.trialId, userAuth.currentClientId, accessToken))
			.then((res) => {
				//TODO need to add grwth phases here
				setGroundDataQuestions(res.data.groundDataQuestions);
				setGrowthStages(res.data.growthStages);
				setPersons(res.data.persons);
				setTrialOutlineData(res.data.trialOutlineData);
				setLoading(false);
			})
			.catch((err) => {
				toast.error("Error trial ground data info. Please try again.");
				console.log(err);
				setLoading(false);
			});
	}

	function onSave(continueProcess) {
		if (continueProcess) {
			history.push(moduleNavigation.createTrialLink(true, null, "analysis"));
		} else {
			history.go(0);
		}
	}

	return loading || !groundDataQuestions ? (
		<Loader active />
	) : (
		<Segment basic>
			<NewGroundData
				groundDataQuestions={groundDataQuestions}
				growthStages={growthStages}
				persons={persons}
				outlineData={trialOutlineData}
				fileName={`${trialOutlineData[0]?.trial}_GroundData_${moment().format("YYYYMMDD_hhmma")}.csv`}
				onSave={onSave}
				level="trial"
			/>
		</Segment>
	);
};

export default TrialGroundData;
